import lightGallery from 'lightgallery';

// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

const gallery = {
    galleries: [],

    init() {
        let self = this;

        let galleryNodes = document.querySelectorAll('.js-gallery')

        if (! galleryNodes) {
            return;
        }

        self._createGalleries(galleryNodes);
    },

    reInit(){
        let self = this;

        self.destroyGalleries();
        self.init();
    },

    _createGalleries(galleryNodes) {
        let self = this;

        galleryNodes.forEach((galleryNode, index) => { 
            self.galleries[index] = lightGallery(galleryNode, {
                plugins: [lgZoom, lgThumbnail],
                licenseKey: '32088F1F-749D4338-9276BA7C-4A5EF243',
                speed: 500,
                exThumbImage: 'data-thumb'
            });
        });
        
    },

    destroyGalleries() {
        let self = this;

        if(self.galleries) {
            self.galleries.forEach(gallery => {
                gallery.destroy();
            });
        }

        self.galleries = [];
    }
}

gallery.init();

document.addEventListener('LokiRequestEnd', function () {
    gallery.reInit();
});



const articleGallery = {
    galleries: [],

    init() {
        let self = this;

        let galleryNodes = document.querySelectorAll('.typography')

        if (! galleryNodes) {
            return;
        }

        self._createGalleries(galleryNodes);
    },

    reInit(){
        let self = this;

        self.destroyGalleries();
        self.init();
    },

    _createGalleries(galleryNodes) {
        let self = this;

        galleryNodes.forEach((galleryNode, index) => { 
            self.galleries[index] = lightGallery(galleryNode, {
                selector: 'img:not(.gallery-ignored)',
                plugins: [lgZoom, lgThumbnail],
                licenseKey: '32088F1F-749D4338-9276BA7C-4A5EF243',
                speed: 500,
                exThumbImage: 'src'
            });
        });
        
    },

    destroyGalleries() {
        let self = this;

        if(self.galleries) {
            self.galleries.forEach(gallery => {
                gallery.destroy();
            });
        }

        self.galleries = [];
    }
}

articleGallery.init();

document.addEventListener('LokiRequestEnd', function () {
    articleGallery.reInit();
});
